import { jsPDF } from 'jspdf';
import { format } from 'date-fns';

interface InvoiceData {
  invoiceNumber: string;
  issueDate: string;
  dueDate: string;
  studentName: string;
  studentId: string;
  startDate: string;
  endDate: string;
  items: Array<{
    description: string;
    amount: number;
  }>;
  totalAmount: number;
  status: string;
  propertyId: string;
  unitNo?: string;
}

const addLogo = async (doc: jsPDF, propertyId: string): Promise<void> => {
  const storedLogos = localStorage.getItem('propertyLogos');
  if (!storedLogos) return;

  const propertyLogos = JSON.parse(storedLogos);
  const propertyLogo = propertyLogos[propertyId];
  
  if (propertyLogo?.logo) {
    try {
      await new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          try {
            const maxWidth = propertyLogo.settings.invoiceSize;
            const aspectRatio = img.width / img.height;
            const width = Math.min(maxWidth, img.width);
            const height = width / aspectRatio;

            doc.addImage(img, 'PNG', 20, 15, width, height);
            resolve(true);
          } catch (err) {
            reject(err);
          }
        };
        img.onerror = () => reject(new Error('Failed to load logo'));
        img.src = propertyLogo.logo;
      });
    } catch (error) {
      console.error('Error adding logo to PDF:', error);
    }
  }
};

export const generateInvoicePDF = async (invoiceData: InvoiceData): Promise<Blob> => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 20;
  const contentWidth = pageWidth - (margin * 2);

  // Add blue header background
  doc.setFillColor(70, 130, 180);
  doc.rect(0, 0, pageWidth, 35, 'F');

  // Add logo
  await addLogo(doc, invoiceData.propertyId);

  // Rest of the PDF generation code...
  // (Keep the existing PDF generation logic)

  return doc.output('blob');
};